import styles from './styles.module.scss';
import { Icons } from 'pages/Profile/components/icons';
import { Button } from 'components';
import { Icons as WorkshopIcons } from 'pages/Workshop/Icons';
import classNames from 'classnames';
import { TaskFiltersType, TasksStatus, TaskType } from '../types';
import { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { DateRangePicker } from 'components/Form/DateRangePicker';

type TaskFiltersPropsType = {
  open: boolean;
  setOpen: Function;
  filters: TaskFiltersType;
  tasksFilterHandler: Function;
};

const TaskFilters = (props: TaskFiltersPropsType) => {
  const { open, setOpen, filters, tasksFilterHandler } = props;
  const [internalFilters, setInternalFilters] = useState<TaskFiltersType>(filters);
  const [resetDates, setResetDates] = useState<boolean>(false);

  useEffect(() => {
    if (open) setInternalFilters(filters);
  }, [open]);

  const handleTasksStatusCheckboxChange = (e, value) => {
    const { taskStatuses } = internalFilters;
    const isChecked = e.target.checked;

    let newTaskStatuses: any[] = [];
    if (isChecked && !taskStatuses.includes(value)) {
      newTaskStatuses = [...taskStatuses, value];
      if (value !== TasksStatus.all && newTaskStatuses.includes(TasksStatus.all)) {
        newTaskStatuses = newTaskStatuses.filter((status) => status !== TasksStatus.all);
      } else if (
        value === TasksStatus.all ||
        (newTaskStatuses.length === 6 && !newTaskStatuses.includes(TasksStatus.all))
      ) {
        newTaskStatuses = [TasksStatus.all];
      }
    } else if (!isChecked && taskStatuses.includes(value)) {
      if (value === TasksStatus.all && taskStatuses.length === 1) {
        newTaskStatuses = Object.values(TasksStatus)
          .filter((status) => status !== TasksStatus.all)
          .map((val) => val);
      } else {
        newTaskStatuses = taskStatuses.filter((type) => type !== value);
        if (!newTaskStatuses.length) newTaskStatuses = [TasksStatus.all];
      }
    }

    setInternalFilters((prev) => ({
      ...prev,
      taskStatuses: newTaskStatuses,
    }));
  };

  const handleTasksTypeCheckboxChange = (e, value) => {
    const { taskTypes } = internalFilters;
    const isChecked = e.target.checked;

    let newTaskTypes: any[] = [];
    if (isChecked && !taskTypes.includes(value)) {
      newTaskTypes = [...taskTypes, value];
    } else if (!isChecked && taskTypes.includes(value)) {
      newTaskTypes = taskTypes.filter((type) => type !== value);
    }

    setInternalFilters((prev) => ({
      ...prev,
      taskTypes: newTaskTypes,
    }));
  };

  return (
    <div className={styles.taskFilters}>
      <div className={styles.header}>
        <div className={styles.heading}>Filters</div>
        <div className={styles.close} onClick={() => setOpen(false)}>
          <Icons variant={Icons.CLOSE} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.title}>Due Date</div>
          <div className={styles.filters}>
            <DateRangePicker
              title={''}
              onDatesChange={(from, to) => {
                resetDates && setResetDates(false);
                setInternalFilters((prev) => ({
                  ...prev,
                  startDate: from,
                  endDate: to,
                }));
              }}
              fromDateValue={internalFilters.startDate}
              toDateValue={internalFilters.endDate}
              dateRangePickerWrapperClass={styles.dateRangePicker}
              resetDates={resetDates}
              futureDisabled={false}
              hideTo
            />
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}>Task Status</div>
          <div className={styles.filters}>
            {Object.values(TasksStatus).map((val) => (
              <div className={styles.checkbox}>
                <Checkbox
                  type="checkbox"
                  name="isPrimary"
                  className="mosaikCheckbox"
                  value={internalFilters.taskStatuses.includes(val)}
                  onChange={(e) => handleTasksStatusCheckboxChange(e, val)}
                  checked={internalFilters.taskStatuses.includes(val)}
                />
                <div className={styles.label}>{val}</div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.section}>
          <div className={styles.title}>Type</div>
          <div className={styles.filters}>
            {Object.values(TaskType).map((val) => (
              <div className={styles.checkbox}>
                <Checkbox
                  type="checkbox"
                  name="isPrimary"
                  className="mosaikCheckbox"
                  value={internalFilters.taskTypes.includes(val)}
                  onChange={(e) => handleTasksTypeCheckboxChange(e, val)}
                  checked={internalFilters.taskTypes.includes(val)}
                />
                <div className={styles.label}>{val}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          type="submit"
          className={classNames(styles.resetButton, styles.sharedButton)}
          title={'Reset'}
          onClick={() => {
            setResetDates(true);
            tasksFilterHandler(null);
          }}
          iconLeft={<WorkshopIcons variant={WorkshopIcons.RESET} />}
        />
        <Button
          type="submit"
          className={classNames(styles.saveButton, styles.sharedButton)}
          title={'Save'}
          onClick={() => tasksFilterHandler(internalFilters)}
        />
      </div>
    </div>
  );
};

export default TaskFilters;
